<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="actCatMain">
          <project-asset
            v-on:project-changed="onProjectChange"
            v-on:vessel-changed="onVesselChange"
          ></project-asset>
          <v-card id="actCatCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
              >{{ $t('nav.DPROutput') }}</v-card-title
            >
            <v-data-table
              id="actCatTable"
              :headers="headers"
              :items="items"
              :items-per-page="15"
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                    <td style="text-align: left">
                    {{ $t(props.item.sectionName) }}
                  </td>
                  <td style="text-align: left">
                    {{ $t(props.item.sectionDescription) }}
                  </td>
                  <td style="text-align: center">
                    <v-checkbox
                      v-model="props.item.visible"
                      @change="hndStateChange(props.item)"
                    ></v-checkbox>
                  </td>

                  <td style="text-align: left">
                    {{ props.item.projectId | projectName(projectsMap) }}
                  </td>
                  <td style="text-align: left">
                    {{ props.item.vesselId | vesselName(vesselsMap) }}
                  </td>

                  
                </tr>
              </template>
            </v-data-table>

            
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import ProjectAsset from '../components/common/ProjectAsset'
import Vue from 'vue'

export default {
  components: {
    'project-asset': ProjectAsset
  },
  data() {
    return {
      dialog: false,
      requiredMessage: this.$t('common.required'),
      headers: [
          {
          text: this.$t('dpr.sectionName'),
          align: 'left',
          value: 'sectionName'
        },
        {
          text: this.$t('column.description'),
          align: 'left',
          value: 'sectionDescription'
        },
        { text: this.$t('column.visible'), align: 'center', value: 'visible' },
        {
          text: this.$t('common.projectName'),
          align: 'left',
          value: 'projectId'
        },
        {
          text: this.$t('common.asset'),
          align: 'left',
          value: 'vesselId'
        },
        
      ],

      editedIndex: -1,
      editedItem: {},
      defaultItem: {},

      maxCode: '',
      selProjectId: null,
      selVesselId: null,
      dlgSelProjectId: null
    }
  },
  computed: {
    ...mapGetters([

      'm_project/getProjectNames',
      'm_project/getProjectsMap',

      'm_vessel/getVesselNames',
      'm_vessel/getVesselsMap',

      'm_passet/getSelProjectId',
      'm_passet/getSelVesselId',

      'm_dprOutput/getDprOutputs'
    ]),

    projects() {
      return this['m_project/getProjectNames'].filter((p) => p.VCount > 0)
    },

    projectsMap() {
      return this['m_project/getProjectsMap']
    },

    vessels() {
      return this['m_vessel/getVesselNames']
    },
    
    vesselsMap() {
      return this['m_vessel/getVesselsMap']
    },

    formTitle() {
      return this.editedIndex === -1
        ? this.$t('common.new') + ' ' + this.$t('nav.DPROutput')
        : this.$t('common.edit') + ' ' + this.$t('nav.DPROutput')
    },

    items() {
      return this['m_dprOutput/getDprOutputs']
    },
    
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  filters: {
    projectName: function (pId, map) {
      return pId ? map[pId] : ''
    },
    vesselName: function (vId, map) {
      return vId ? map[vId] : ''
    }
  },

  created() {
    this.selProjectId = this['m_passet/getSelProjectId']
    this.selVesselId = this['m_passet/getSelVesselId']

    Vue.$log.debug('load dpr outputs', this.selProjectId, this.selVesselId)

    this['m_dprOutput/fetchDprOutputs']({
      pId: this.selProjectId,
      vId: this.selVesselId
    })
  },
  methods: {
    ...mapMutations(['mHideLongLoader']),
    ...mapActions([
      'm_dprOutput/fetchDprOutputs',
      'm_dprOutput/updateDprOutputs',
      'm_dprOutput/toggleConfiguration'
    ]),

    refreshDprOutputs() {
      this['m_dprOutput/fetchDprOutputs']({
        pId: this.selProjectId,
        vId: this.selVesselId
      })
    },

    onProjectChange(value) {
      this.selProjectId = value
      this.refreshDprOutputs();
    },

    onVesselChange(value) {
      this.selVesselId = value
      this.refreshDprOutputs();
    },

    hndStateChange(item) {
      this.$log.debug('column', item.sectionName, 'state change: visible?', item.visible);
      this['m_dprOutput/toggleConfiguration'](item);
    },

    resetEntity(item) {
      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    editItem(item) {
      this.resetEntity(item)
      this.dialog = true
    },

    close() {
      this.dialog = false
      this.resetEntity()
    },

    save() {
      this['m_dprOutput/updateDprOutputs'](this.editedItem).then(() => this.refreshDprOutputs())
      this.refreshConfigurations()
      this.close()
    }
  }
}
</script>

<style>
#actCatTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#actCatTable header {
  font-weight: bold;
}
#actCatCard {
  width: auto;
}
</style>